import HeadedModal from '@paradigm/design-system/src/components/HeadedModal';

import { Order } from '@paradigm/features/src/unified-rfqs/entities/shared';
import { useMaybeOrder } from '@paradigm/features/src/unified-rfqs/contexts/unified-orders';
import {
  useContextMenuActions,
  useContextMenuView,
} from '../context-menu/context-menu';
import RfqDetailsModal from '../drfq/rfq-details-bottom-table/RfqDetailsModal';

const MODAL_WIDTH = 750;

export default function OrderDetailsModal() {
  const { detailsItemId: orderId, isItemDetailsOpen } = useContextMenuView();

  if (!isItemDetailsOpen) return null;

  if (orderId == null) return <NoOrderFound />;

  return <OrderDetailsModalContent orderId={orderId} />;
}

function OrderDetailsModalContent({ orderId }: { orderId: Order['id'] }) {
  const order = useMaybeOrder(orderId);

  if (order == null) return <NoOrderFound />;

  // For now we just display view details for DRFQs
  if (order.rfqType === 'grfq') return null;

  return <RfqDetailsModal />;
}

function NoOrderFound() {
  const { isItemDetailsOpen } = useContextMenuView();
  const { closeDetailsModal } = useContextMenuActions();
  return (
    <HeadedModal
      title="Details"
      isOpen={isItemDetailsOpen}
      close={closeDetailsModal}
      width={MODAL_WIDTH}
    >
      <p css="color: red; margin: 2rem; text-align: center">
        Order not found 😓
      </p>
    </HeadedModal>
  );
}
